import { PageResult } from '../../models';
import { PlatformUser, PlatformWorkspace, GlobalAccessSummary } from '../../models/platform-user/platform-user.model';
import { PlatformUserFilter } from '../../models/platform-user/platform-user-filter.model';
import { PageParams } from '../../models/page-params.model';
import { UIConfig } from './config-service';
import { CCApiService } from './api-service';
import { buildQueryString, QueryParamValue } from '../../utils/query-string.helper';

export class PlatformUserApiService {
  // Not readonly: assigned once at bootstrap by init() below, which needs a runtime
  // UIConfig unavailable at class-definition time -- same pattern as every other
  // *ApiService class in this codebase (e.g. CustomerApiService).
  static ApiService: CCApiService; // NOSONAR
  static apiBasePath: string; // NOSONAR
  static platformUsersAPI: string; // NOSONAR

  static init(config: UIConfig) {
    this.ApiService = new CCApiService(config.authClientId, config.authIssuerUri);
    this.apiBasePath = config.apiBasePath;
    this.platformUsersAPI = `${this.apiBasePath}/platform-users`;
  }

  static getQueryString(params: Record<string, QueryParamValue | null | undefined> = {}): string {
    return buildQueryString(params);
  }

  private static expandStatusFilter(status?: string[]): string[] | undefined {
    if (!status) {
      return status;
    }
    return status.flatMap((value) => (value === 'PASSWORD_EXPIRED' ? ['PASSWORD_EXPIRED', 'RECOVERY'] : [value]));
  }

  static async getPlatformUsers(filter: PlatformUserFilter = {}): Promise<PageResult<PlatformUser>> {
    const requestFilter: PlatformUserFilter = { ...filter, status: this.expandStatusFilter(filter.status) };
    return this.ApiService.performFetch(
      `${this.platformUsersAPI}${this.getQueryString(requestFilter as Record<string, QueryParamValue | null | undefined>)}`
    );
  }

  static async getUserWorkspaces(userId: string, pageParams: PageParams = {}): Promise<PageResult<PlatformWorkspace>> {
    return this.ApiService.performFetch(
      `${this.platformUsersAPI}/${userId}/workspaces${this.getQueryString(pageParams as Record<string, QueryParamValue | null | undefined>)}`
    );
  }

  static async getGlobalAccess(userId: string): Promise<GlobalAccessSummary> {
    return this.ApiService.performFetch(`${this.platformUsersAPI}/${userId}/global-access`);
  }
}
